'use client'

import { ListicleCard } from './listicle-card'
import type { ListicleCardText, ListicleCardView } from './types'

import { ListicleShowMore } from '../listicle-items'

interface ListicleRecommendationsProps {
  cards: ListicleCardView[]
  text: ListicleCardText
}

// The first three cards still render into server HTML. The rest stay as small
// view records until Show more; their unused JSX no longer fills the RSC cache.
export const ListicleRecommendations = ({ cards, text }: ListicleRecommendationsProps) => {
  const renderCards = (items: ListicleCardView[]) =>
    items.map((card) => <ListicleCard key={card.uid} card={card} text={text} />)
  return (
    <ListicleShowMore
      initial={renderCards(cards.slice(0, 3))}
      extra={renderCards(cards.slice(3))}
      hasMore={cards.length > 3}
    />
  )
}
